<template>
  <header class="site-header">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <a class="navbar-brand d-flex align-items-center gap-2" href="/">
          <div class="logo-container">
            <SiteLogo />
          </div>
          <span class="navbar-brand-site d-none d-sm-block">Building, Renovation<br> and Project Planning Portal</span>
        </a>
        <EnvBadge />

        <SiteNavigation />
      </div>
    </nav>
  </header>
</template>

<script setup>
import EnvBadge from '@shared/components/EnvBadge.vue'
import SiteNavigation from '@shared/components/SiteNavigation.vue'
import SiteLogo from './SiteLogo.vue'
</script>
